const React = require("react")
const Lock = ({ ...props }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.332 14H4.66536C3.9287 14 3.33203 13.4033 3.33203 12.6667V7.33333C3.33203 6.59667 3.9287 6 4.66536 6H11.332C12.0687 6 12.6654 6.59667 12.6654 7.33333V12.6667C12.6654 13.4033 12.0687 14 11.332 14Z"
        stroke="#0087DC"
        strokeWidth="1.4655"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6654 6V4.66667C10.6654 3.194 9.47136 2 7.9987 2V2C6.52603 2 5.33203 3.194 5.33203 4.66667V6"
        stroke="#0087DC"
        strokeWidth="1.4031"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99607 9.66602C7.81207 9.66602 7.66274 9.81535 7.66407 9.99935C7.66407 10.1833 7.8134 10.3327 7.9974 10.3327C8.1814 10.3327 8.33074 10.1833 8.33074 9.99935C8.33074 9.81535 8.1814 9.66602 7.99607 9.66602"
        stroke="#0087DC"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

module.exports = {
  Lock
}



// WEBPACK FOOTER //
// ./src/shared/skin/icons/prompt/icons/lock.js